// extracted by mini-css-extract-plugin
export var actionButton = "_nx-0";
export var actionMenuContainer = "_nx-i";
export var bubble = "_nx-2";
export var bubbleActionMenu = "_nx-j";
export var bubbleContext = "_nx-6";
export var bubbleItems = "_nx-7";
export var customer = "_nx-3";
export var divider = "_nx-8";
export var fileList = "_nx-9";
export var hiddenComment = "_nx-o";
export var infoAbove = "_nx-a";
export var internal = "_nx-4";
export var lightActionButton = "_nx-1";
export var link = "_nx-b";
export var merchant = "_nx-5";
export var message = "_nx-c";
export var profilePicture = "_nx-e";
export var quillToolbarContainer = "_nx-f";
export var senderDate = "_nx-g";
export var senderDateCustomer = "_nx-h";
export var senderName = "_nx-d";
export var time = "_nx-k";
export var uploadedImage = "_nx-l";
export var username = "_nx-m";
export var xsmall = "_nx-n";